import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import TaskCreationWizard from '../components/TaskCreationWizard';

export default function NewTaskPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Create Task - MAIA Agent 128</title>
      </Helmet>
      <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-5xl mx-auto px-4">
        <div className="mb-8">
          <button
            onClick={() => navigate('/tasks')}
            className="text-sm text-gray-600 hover:text-black mb-4 inline-flex items-center"
          >
            ← Back to Tasks
          </button>
          <h1 className="text-3xl font-bold">Create New Task</h1>
          <p className="mt-2 text-gray-600">
            Submit a task for Universal Agent 128 to process with step-by-step guidance
          </p>
        </div>

        <TaskCreationWizard />
      </div>
    </div>
    </>
  );
}
